import { INIT, SUCCESS, ERROR, LOADING } from 'utils/asyncStatusHelper';
import {
	GET_PHONEPE_BALANCE_REQUEST,
	GET_PHONEPE_BALANCE_ERROR,
	GET_PHONEPE_BALANCE_SUCCESS,
	DRAW_PHONEPE_BALANCE_REQUEST,
	DRAW_PHONEPE_BALANCE_ERROR,
	DRAW_PHONEPE_BALANCE_SUCCESS,
	CLEAR_GET_PHONEPE_BALANCE,
	ACTIVATE_PHONEPE_REQUEST,
	ACTIVATE_PHONEPE_SUCCESS,
	ACTIVATE_PHONEPE_ERROR
} from 'actions/MyAccountActions/walletActions';

import { createReducer } from 'utils/reducerUtils';

const defaultState = {
	asyncStatus: INIT
};

export const drawBalance = createReducer(
	DRAW_PHONEPE_BALANCE_REQUEST,
	DRAW_PHONEPE_BALANCE_SUCCESS,
	DRAW_PHONEPE_BALANCE_ERROR,
	defaultState
);

export const activatePhonePe = createReducer(
	ACTIVATE_PHONEPE_REQUEST,
	ACTIVATE_PHONEPE_SUCCESS,
	ACTIVATE_PHONEPE_ERROR,
	defaultState
);

export function walletBalance(state = defaultState, action = {}) {
	switch (action.type) {
		case GET_PHONEPE_BALANCE_REQUEST:
			return Object.assign({}, state, {
				asyncStatus: LOADING
			});
		case GET_PHONEPE_BALANCE_SUCCESS:
			return Object.assign({}, state, {
				asyncStatus: SUCCESS,
				data: action.data
			});
		case GET_PHONEPE_BALANCE_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				error: action.error
			});
		case CLEAR_GET_PHONEPE_BALANCE:
			return defaultState;
		default:
			return state;
	}
}
